// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"Hero_logo_wrapper__WNNjy","logo":"Hero_logo__HPWUO","attack":"Hero_attack__SHTDr","content":"Hero_content__nBFN-"};